/**
 * Silence diagnostic console output in production builds.
 *
 * Why: many modules ship `console.info(...)` calls for ops/debug tracing
 * (admin upload pipeline, http transport, etc.). Those are useful in dev/staging
 * but pollute the DevTools console for every customer in production.
 *
 * What we keep:
 *   - console.error  (genuine errors → still useful for users reporting bugs)
 *   - console.warn   (legit deprecation/recovery notices)
 *
 * What we silence:
 *   - console.info, console.debug, console.log (diagnostic noise)
 *
 * Override: set localStorage.PINKSISLY_DEBUG = '1' to re-enable in production
 * (handy for support remote-diagnosing a customer's session).
 */
if (process.env.NODE_ENV === 'production') {
  try {
    const debugEnabled =
      typeof window !== 'undefined' &&
      window.localStorage &&
      window.localStorage.getItem('PINKSISLY_DEBUG') === '1';

    if (!debugEnabled) {
      const noop = () => {};
      // Keep error + warn for real issues. Silence everything else.
      console.log = noop;
      console.info = noop;
      console.debug = noop;
      console.trace = noop;
    }
  } catch {
    // localStorage may throw in private/iframe contexts — fall through silently.
  }
}
